<template>
  <div style="margin-top: 20px">
    <Spinner :isLoading="isLoading" />
    <a ref="topSection" />
    <!-- <base-header class="pb-6 bg-primary">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">PE LIVE</h6>
        </b-col>
      </b-row>
    </base-header> -->
    <div class="container-fluid mt--6">
      <template v-if="!isQuoteOfferSent">
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">


          <b-card class="uBind">
            <b-row>
              <h2 class="secondary-card-header">
                New or existing customer?
              </h2>
            </b-row>



            <b-row>
              <b-col md="12">
                <base-input label="Would you like to create a quote for a new or existing customer?">
                  <button-radio-group @change="changeModeClicked($event)" id="btn-radios-1" v-model="formMode" :options="[
                    {
                      label: 'New',
                      value: 'new',
                    },
                    {
                      label: 'Existing',
                      value: 'existing',
                    },

                  ]" name="radios-btn-default" buttons style="margin-top: 20px;"></button-radio-group>
                </base-input>
              </b-col>
            </b-row>


            <b-row v-if="formMode == 'existing'">
              <b-col md="6">
                <base-input name="Insured Name" label="Select Existing Customer" inputGroupClasses="uBind-input"
                  :rules="formRules.insuredName">
                  <el-select id="insuredDD" @blur="InsuredNameBlurred($event)" @visible-change="visibleChange($event)"
                    @keyup.native="setInsuredName($event)" @change="selectCustomer($event)"
                    v-model="model.selectedCustomerId"
                    :rules="formRules.insuredName" filterable clearable placeholder="Search previous customers"
                    v-cancel-read-only>
                    <el-option class="style-dropdown" v-for="(option, index) in customerList"
                      :key="option.Customer_id || index"
                      :label="option.Customer_insured_name + ' (' + option.Customer_contact_first_name + ' ' + option.Customer_contact_last_name + ')'"
                      :value="option.Customer_id">
                      <span>
                        <i
                          :class="option.Customer_email_opt_out ? 'fas fa-times text-danger' : 'fas fa-check text-success'"
                          class="mr-2"
                          aria-hidden="true"
                        ></i>
                        {{ option.Customer_insured_name }} ({{ option.Customer_contact_first_name }} {{ option.Customer_contact_last_name }})
                      </span>
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="6"> </b-col>
            </b-row>



          </b-card>


          <b-card class="uBind">
            <b-row>
              <h2 class="secondary-card-header">
                Business Details
              </h2>
            </b-row>

            <b-row>
              <b-col md="6">
                <base-input label="Please enter the business name" placeholder="eg. ACME services"
                  v-model="model.insuredName" :disabled="fieldsDisabled.insuredName"
                  inputGroupClasses="uBind-input" />
              </b-col>
              <b-col md="6" style="margin-top:36px">
                <base-button @click="searchBusiness()" type="danger" class="mb-4 bg-danger">Search</base-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <div>
                  <a class="abn-link" target="_blank" href="https://abr.business.gov.au/">Don't know the ABN?</a>
                </div>
                <base-input type="text" name="Insured ABN" label="Insured ABN" pattern="[0-9]{11}"
                  v-model="model.insuredABN" :disabled="fieldsDisabled.insuredABN" :rules="formRules.insuredABN"
                  prependIcon="fas fa-certificate" inputGroupClasses="uBind-input" />
              </b-col>
              <b-col md="2">
                <base-input type="text" name="Years in Business" label="Yrs in Business"
                  v-model="model.yrsInOperation" :disabled="true" inputGroupClasses="uBind-input" />
              </b-col>
              <b-col md="6">
                <base-input name="Business Description" label="Business Description" inputGroupClasses="uBind-input"
                  :rules="formRules.equipmentDescription">
                  <el-select v-model="model.businessDesc">
                    <el-option v-for="option in businessDescriptionsOptions" :key="option.value"
                      :label="replaceAmp(option.label)" :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
            </b-row>
          </b-card>

          <b-card no-body class="mb-4">
            <b-card-header>
              <h3 class="mb-0">Insured Details</h3>
            </b-card-header>

            <b-card-body>
              <div v-html="certContents"></div>



              <b-row>
                <b-col md="6">
                  <base-input name="Contact First Name" label="Contact First Name" :rules="formRules.contactFName"
                    v-model="model.contactFName" :disabled="fieldsDisabled.contactFName" placeholder="John" />
                </b-col>
                <b-col md="6">
                  <base-input name="Contact Last Name" label="Contact Last Name" :rules="formRules.contactLName"
                    v-model="model.contactLName" :disabled="fieldsDisabled.contactLName" placeholder="Smith" />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <base-input label="Contact Phone Number" name="Contact Phone Number" :rules="formRules.contactPhone"
                    v-model="model.contactPhone" :disabled="fieldsDisabled.contactPhone" />
                </b-col>
                <b-col md="6">
                  <base-input name="Contact Email" label="Contact Email" :rules="formRules.contactEmail"
                    v-model="model.contactEmail" :disabled="fieldsDisabled.contactEmail"
                    placeholder="john@example.com" />
                </b-col>
              </b-row>
              <!--
              <b-row>
                <b-col md="12" class="mb-4">
                  <label for="addrs_1" class="form-control-label">
                    Search Insured Address
                  </label>
                  <input
                    style="cursor: text"
                    @blur="clearAddressFields"
                    class="form-control"
                    id="addrs_1"
                    v-model="model.insuredStreet"
                    :disabled="fieldsDisabled.insuredStreet"
                    :rules="formRules.insuredStreet"
                  />
                </b-col>
              </b-row>
               <b-row>
                <b-col md="4">
                  <base-input
                    label="City"
                    v-model="model.insuredCity"
                    :disabled="fieldsDisabled.insuredCity"
                    :rules="formRules.insuredCity"
                  />
                </b-col>
                <b-col md="4">
                  
                  <base-input
                    name="State"
                    label="State"
                    :rules="formRules.insuredState"
                  >
                    <el-select
                      v-model="model.insuredState"
                      :disabled="fieldsDisabled.insuredState"
                    >
                      <el-option
                        v-for="option in states"
                        :key="option.label"
                        :label="option.label"
                        :value="option.value"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input
                    label="Postcode"
                    type="number"
                    v-model="model.insuredPostcode"
                    :disabled="fieldsDisabled.insuredPostcode"
                  />
                </b-col>
              </b-row> -->
            </b-card-body>
          </b-card>

          <b-card class="uBind">
            <b-row>
              <h2 class="secondary-card-header">
                Address Details
              </h2>
            </b-row>

            <b-row>
              <b-col md="12" class="mb-4 uBind-input">
                <label for="addrs_1" class="form-control-label">
                  Search Insured Address
                </label>
                <input autocomplete="new-password" style="cursor: text" @blur="clearAddressFields" class="form-control"
                  id="addrs_1" v-model="model.insuredStreet" :disabled="fieldsDisabled.insuredStreet"
                  :rules="formRules.insuredStreet" />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <base-input label="City" v-model="model.insuredCity" :disabled="fieldsDisabled.insuredCity"
                  :rules="formRules.insuredCity" inputGroupClasses="uBind-input" />
              </b-col>
              <b-col md="4">
                <!-- <base-input label="State" v-model="model.insuredState" /> -->
                <base-input name="State" label="State" :rules="formRules.insuredState" inputGroupClasses="uBind-input">
                  <el-select v-model="model.insuredState" :disabled="fieldsDisabled.insuredState">
                    <el-option v-for="option in states" :key="option.label" :label="option.label" :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="4">
                <base-input autocomplete="off" label="Postcode" type="number" v-model="model.insuredPostcode"
                  :disabled="fieldsDisabled.insuredPostcode" inputGroupClasses="uBind-input" />
              </b-col>
            </b-row>
          </b-card>

          <b-card no-body class="mb-4" v-if="formInitData != null">
            <b-card-header>
              <h2 class="secondary-card-header">
                Equipment and Finance Details
              </h2>

              <h4>
                Choose one or more Equipment Categories
              </h4>
            </b-card-header>





            <b-card-body>


              <b-row>
                <b-col md="12">
                  <base-button
                    :class="[{ 'eq-selected': selectEquipmentItems.find(f => f.categoryItemId == option.categoryItemId) }]"
                    v-for="(option, index) in formInitData.equipmentCategories" :key="index"
                    @click="toggleEquipmentItem(option)" type="uBind" class="mt-2 mt-sm-0 mb-4">
                    <i v-if="!selectEquipmentItems.find(f => f.categoryItemId == option.categoryItemId)"
                      class="fas fa-plus pr-3"></i>
                    <i v-if="selectEquipmentItems.find(f => f.categoryItemId == option.categoryItemId)"
                      class="fas fa-check pr-3"></i>
                    {{ option.categoryName }}
                    <el-tooltip placement="top-start" effect="dark">
                      <div slot="content" style="font-size: 13px; max-width: 400px;">
                        {{ option.categoryTooltip }}
                      </div>
                      <i class="fas fa-info-circle pl-2"></i>
                    </el-tooltip>
                  </base-button>


                </b-col>


              </b-row>

              <b-card no-body class="mb-4 ubind" style="border: 2px solid"
                v-for="(option, index) in selectEquipmentItems" :key="index">
                <b-card-header>
                  <h4>
                    {{ option.categoryName }}
                  </h4>
                </b-card-header>
                <b-card-body>

                  <!-- <b-row>
                    <b-col md="12">
                      <base-input name="Excess" label="Excess">
                        <el-select v-model="model.excess" :disabled="fieldsDisabled.excess">
                          <el-option v-for="option in excessOptions" :key="option.label" :label="option.label"
                            :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
        
                  </b-row> -->

                  <!-- <b-row>
                    <b-col md="12">
                      <base-input name="Equipment Description(s)" label="Equipment Description(s)"
                        :rules="formRules.equipmentDescription" placeholder="I.e. Year, Make, Model"
                        v-model="model.equipmentDescription" :disabled="fieldsDisabled.equipmentDescription" />
                    </b-col>
                  </b-row> -->
                  <b-row>
                    <b-col md="6">
                      <!-- <base-input name="Excess" label="Excess">
                        <el-select v-model="model.excess" :disabled="fieldsDisabled.excess">
                          <el-option v-for="option in excessOptions" :key="option.label" :label="option.label"
                            :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input> -->
                      <base-input name="Excess" label="Excess">
                        <base-button v-for="(excessoption, index) in option.excessOptions" :key="index"
                          @click="selectExcess(excessoption, option)" :disabled="!excessoption.enabled" type="default"
                          size="sm" class="mb-4"
                          v-bind:style="option.selectedExcess == excessoption.value ? 'background-color: red; color: white;' : 'background-color: white; color: black;'">{{
                            excessoption.label }}</base-button>
                      </base-input>
                    </b-col>
                    <b-col md="6">
                      <base-input
                        name="Specified Sum Insured"
                        label="Specified Sum Insured"
                        type="text"
                        inputmode="decimal"
                        prepend-icon="fas fa-dollar-sign"
                        :rules="formRules.equipmentValue"
                        :preserveCursor="true"
                        :selectOnFocus="true"
                        :value="option.insuredAmount"
                        @input="onSpecifiedSumInsuredInput(option, $event)"
                      />
                    </b-col>
                    <!-- <b-col md="6">
                      <base-input name="Unspecified Sum Insured" label="Unspecified Sum Insured" type="number"
                        prepend-icon="fas fa-dollar-sign" :rules="formRules.equipmentValue" v-model="model.equipmentValue"
                        :disabled="fieldsDisabled.equipmentValue" />
                    </b-col> -->
                    <!-- <b-col md="6">
                  <base-input name="Equipment Type" label="Equipment Type">
                    <el-select v-model="model.equipmentType" :disabled="fieldsDisabled.equipmentType">
                      <el-option v-for="option in equipmentTypes" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>


                </b-col> -->
                    <!-- <b-col md="4">
                  <base-input
                    name="Area of Operation"
                    label="Area of Operation"
                  >
                    <el-select
                      v-model="model.operatingArea"
                      :disabled="fieldsDisabled.operatingArea"
                    >
                      <el-option
                        v-for="option in operatingAreas"
                        :key="option.label"
                        :label="option.label"
                        :value="option.value"
                      >
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col> -->
                  </b-row>



                </b-card-body>
              </b-card>
              <!-- 
              <b-row>
                <b-col md="6">
                  <div style="margin-top: 10px; margin-bottom: 30px; font-size: 13px !important">
                    No equipment types selected
                  </div>
                </b-col>
              </b-row> -->

              <b-row>
                <b-col md="6">
                  <base-input @change="changeInceptionDate" name="Inception Date (Estimated)" label="Inception Date"
                    :rules="formRules.policyStart" type="date" v-model="model.policyStart" />
                </b-col>

                <b-col md="6">
                  <base-input name="Expiry Date" type="date" disabled label="Expiry Date" :rules="formRules.expiryDate"
                    v-model="model.expiryDate" />
                </b-col>

              </b-row>




              <!-- <b-row>
                <b-col md="6">

                  <base-input name="RegisteredGST" label="Registered for GST?">
                    <base-switch on-text="Yes" off-text="No" v-model="model.registeredForGST">
                    </base-switch>
                  </base-input>

                </b-col>

              </b-row> -->
              <!-- <b-row>
                <b-col md="6">
                  <base-input name="MoreThan50k"
                    label="Are there any of the items you are quoting worth more than $50,000 each?">
                    <base-switch on-text="Yes" off-text="No" v-model="model.moreThan50k">
                    </base-switch>
                  </base-input>
                </b-col>

              </b-row> -->



            </b-card-body>
          </b-card>

          <div class="text-center" v-if="showGetPremiumButton">
            <b-row align-v="center">
              <b-col>
                <base-button :disabled="!isFormValid" @click="doQuote()" type="danger" class="mb-4 bg-danger">Get
                  Premium</base-button>
              </b-col>

            </b-row>
            <!-- <div v-if="model.Customer_policy_status == 'in_progress' ||
              brokerObj.Broker_super_admin
              ">
              <b-row align-v="center" v-if="formMode == 'view'">
                <b-col>
                  <base-button @click="editQuote()" type="danger" class="mb-4 bg-danger">Edit Quote</base-button>
                </b-col>
              </b-row>

              <b-row align-v="center" v-if="formMode == 'edit'">
                <b-col>
                  <base-button @click="updateQuote()" type="danger" class="mb-4 bg-danger">Update Quote</base-button>
                </b-col>
              </b-row>
            </div> -->
          </div>

          <!-- <base-button :disabled="!isFormValid" @click="updateQuote()" type="danger" class="mb-4 bg-danger">Update
            Premium</base-button> -->






          <a ref="calcSection" />
          <b-card no-body class="mb-4" v-if="showPremiumPanel">
            <b-card-header>
              <h3 class="mb-0">Premium</h3>
            </b-card-header>
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <base-input disabled prepend-icon="fas fa-dollar-sign"
                    :value="totalPremiumIncFeesDisplay" name="Total Insurance Premium"
                    label="Total Insurance Premium (inc all fees and charges)" />
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium" prepend-icon="fas fa-dollar-sign" readonly
                    name="Insurance Premium" label="Insurance Premium" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_gst" prepend-icon="fas fa-dollar-sign"
                    readonly name="Premium GST" label="Premium GST" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_stamp_duty"
                    prepend-icon="fas fa-dollar-sign" readonly name="Stamp Duty" label="Stamp Duty" />
                </b-col>
                <b-col md="3">
                  <base-input v-model="model.Customer_policy_fee" prepend-icon="fas fa-dollar-sign" readonly
                    name="Policy Fee" label="Policy Fee" />
                </b-col> 
              </b-row> -->
              <!-- <b-row>
                <b-col md="12">
                  <h5 style="font-size: 11pt !important">Notes:</h5>
                  <div style="margin-bottom: 25px">
                    <ul style="font-size: 11px;margin-bottom: 5px;" v-for="(option, index) in quoteNotes" :key="index">
                      <li style="font-size: 11px;margin-bottom: 5px;">{{ option }}</li>
                    </ul>
                  </div>
                </b-col>
              </b-row> -->
              <b-row>
                <b-col md="6">
                  <base-input name="Financier" label="Financier (If known)">
                    <el-select id="financierDD" @change="readFinancier($event)" v-model="model.financier" filterable>
                      <el-option v-for="option in financiers" :key="option.label" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="6">
                  <base-input id="financierOther" v-bind:disabled="financierOtherDisabled"
                    placeholder="Select 'Other' in dropdown to activate this field" name="Financier - Other"
                    label="Financier - Other" v-model="model.financierOther" />
                </b-col>
              </b-row>


              <b-row>
                <b-col md="6">
                  <div class="example-btn">
                    <ul>
                      <li v-for="(file, index) in fileList" :key="uploaderKey + '_file_' + index">
                        <div style="display: inline-block">{{ file.name }}</div>
                        <div v-if="!file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                          Please wait...file processing
                        </div>
                        <div v-if="file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                          Upload successful
                        </div>
                      </li>
                    </ul>
                    <div
                      style="display: block; font-weight: 600;font-size: 0.875rem; color: #525f7f; margin-bottom: 20px">
                      Please upload equipment invoice if available
                    </div>
                    <file-upload class="btn btn-primary btn-uploader" :custom-action="customAction"
                      extensions="gif,jpg,jpeg,png,webp,doc,docx,pdf,xls,xlsx,csv"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/msword,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      multiple v-model="fileList" @input-filter="inputFilter" @input-file="inputFile" :input-id="uploaderKey"
                      :ref="uploaderKey" active="true">
                      <i class="fa fa-plus"></i>
                      Select files
                    </file-upload>
                  </div>

                </b-col>
              </b-row>

              <!-- v-if="mode == 'view' &&
                model.Customer_policy_status == 'in_progress'
              " -->

              <div class="text-center" v-if="showSendOfferActions">
                <b-row class="justify-content-center">
                  <b-col cols="12" md="auto">
                    <base-button :disabled="filesUploading" @click="emailOffer('customer')" type="danger"
                      class="mb-4 bg-danger">Send to Customer</base-button>
                  </b-col>

                  <!-- Send to broker section (hidden per ps-live createQuote UX)
                  <b-col>
                    <b-row style="align-items: end;">
                      <b-col>
                        <base-input v-if="sentToBroker == false" name="brokerSelect" label="Please select Broker">
                          <el-select id="brokerDD" @change="readBrokerEmail($event)" v-model="selectedBrokerEmail"
                            filterable>
                            <el-option v-for="option in brokerEmailList" :key="option.label" :label="option.label"
                              :value="option.value">
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col>
                        <base-button :disabled="selectedBrokerEmail == ''" v-if="sentToBroker == false" @click="emailOffer('broker')" type="danger"
                          class="mb-4 bg-danger">Send to Broker</base-button>



                      </b-col>
                    </b-row>
                    <div v-if="sentToBroker == true">Thank you, this quote has been sent to the broker.</div>


                  </b-col>
                  -->
                </b-row>
              </div>
              <!-- <div class="text-center" v-if="model.Customer_policy_status == 'offer_sent_awaiting_information'">
                <b-row align-v="center">
                  <b-col>
                    <base-button @click="emailOffer()" type="danger" class="mb-4 bg-danger">Resend Customer Insurance
                      Offer</base-button>
                  </b-col>
                </b-row>
              </div> -->
            </b-card-body>
          </b-card>
        </form>
      </validation-observer>
      </template>
      <template v-else>
        <b-card class="uBind">
          <h3 class="secondary-card-header">Thank you</h3>
          <div style="margin-bottom: 1.25rem;">
            Thank you. A consent email has been sent{{ quoteOfferSentRecipient }}.
            Once they confirm, the indicative quote will be emailed automatically.
          </div>
          <div class="text-center">
            <base-button type="danger" class="mb-4 bg-danger" @click="goToPSCreateQuote">
              Create new Quote
            </base-button>
          </div>
        </b-card>
      </template>
    </div>

    <b-modal class="modal fade" ref="abn-modal" centered size="lg" scrollable>
      <template v-slot:modal-header>
        <slot name="header">
          <h6 class="modal-title">Search for ABN</h6>
        </slot>
        <slot name="close-button">
          <button type="button" class="close" @click="closeModal" data-dismiss="modal" aria-label="Close">
            <span>×</span>
          </button>
        </slot>
      </template>

      <div style="height: 400px; width: 100%; margin-bottom: 20px;">
        <div style="display: flex; flex-direction: row;">
          <div style="flex-basis: 80%;">
            <input placeholder="eg. ACME PTY LTD" autocomplete="new-password" style="cursor: text" class="form-control"
              id="searchABN" v-model="searchABNstring" />
          </div>
          <div>
            <b-button type="button" variant="danger" class="ml-auto" @click="searchForABNFromModal">Search</b-button>
          </div>
        </div>

        <div
          style="display: flex;flex-direction: row; width: 100%; height: 30px; margin-top: 30px; font-weight: bold; border-bottom: 1px solid lightgray; margin-bottom: 20px;">
          <div style="flex-basis: 40%;">
            Name
          </div>
          <div style="flex-basis: 20%;">
            ABN
          </div>
          <div style="flex-basis: 15%;">
            State
          </div>
          <div style="flex-basis: 15%;">
            Postcode
          </div>
          <div style="flex-basis: 10%;">

          </div>
        </div>

        <div style="display: flex;flex-direction: row; width: 100%; align-items: center; margin-bottom: 10px;"
          v-for="(item, index) in ABNSearchResults" :key="index">
          <div style="flex-basis: 40%;">
            {{ item.organisationName }}
          </div>
          <div style="flex-basis: 20%;">
            {{ item.ABN }}
          </div>
          <div style="flex-basis: 15%;">
            {{ item.state }}
          </div>
          <div style="flex-basis: 15%;">
            {{ item.postCode }}
          </div>
          <div style="flex-basis: 10%;">
            <b-button type="button" variant="danger" class="ml-auto" @click="useABNResult(item)">Use</b-button>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <div></div>
      </template>
    </b-modal>

    </div>
  </div>
</template>

<script>
import BaseInput from "../components/Inputs/BaseInput.vue";
import { Select, Option } from "element-ui";
import axios from "axios";
import { dropDowns } from "../assets/data/dropdown_values";
import { entsiaDropDowns } from "../assets/data/entsiaLOVs";
import { quoteFormMethods } from "../helpers/quoteForm";
import { GlobalStore } from "../globalStore";
import { emailMethods } from "../helpers/email";
import { appFunctions } from "../helpers/appFunctions";
import { protecsureFunctions } from "../helpers/protecsure";
import Spinner from "../views/dashboard/Spinner.vue";
import ButtonRadioGroup from "../components/ButtonRadioGroup.vue";
import FileUpload from 'vue-upload-component'
import { GlobalMethods } from "../globalMethods";
import { peQuoteStatus } from "../constants/peQuoteStatus";
// import { addYears } from "date-fns";
// import QuotesAndPoliciesVue from "../views/QuotesAndPolicies.vue";

export default {
  name: "QuoteForm",
  policy_id: "",
  selectedCustomerId: 0,
  props: {
    rawModel: null,
    model: {
      type: Object,
      default: {
        policyStart: "123",
        expiryDate: "456",
        insuredName: "",
        insuredABN: "",
        yrsInOperation: "",
        businessDesc: "",
        contactFName: "",
        contactLName: "",
        contactEmail: "",
        contactPhone: "",
        insuredAddress: "",
        insuredStreet: "",
        insuredCity: "",
        insuredState: null,
        insuredPostcode: "",
        equipmentDescription: "",
        equipmentValue: 0,
        equipmentType: "",
        operatingArea: "",
        usedOnPublicRoad: "",
        insurancePeriod: "12 Months",
        financier: "",
        financierOther: "",
        Customer_policy_insurance_total_premium: null,
        Customer_policy_insurance_total_premium_plus_fees: null,
        Customer_policy_insurance_premium: null,
        Customer_policy_insurance_premium_gst: null,
        Customer_policy_insurance_premium_stamp_duty: null,
        Customer_policy_fee: null,
        Customer_policy_status: null
      }
    },
    mode: {
      type: String,
      default: "editable"
    }
  },
  data() {
    return {
      businessDescriptionsOptions: entsiaDropDowns.businessDescriptionsOptions,
      ABNSearchResults: [],
      searchABNstring: "",
      selectedBrokerEmail: "",
      brokerEmailList: [],
      quoteId: null,
      quoteModified: false,
      hasQuotedPremium: false,
      uiMode: "editable",
      isLoading: false,
      formValid: false,
      formInitData: null,
      selectEquipmentItems: [],
      quoteNotes: [],
      certContents: "",
      realmApp: null,
      formMode: "new",
      financiers: dropDowns.financiers,
      equipmentTypes: dropDowns.protecSureEquipmentTypes,
      states: dropDowns.states,
      operatingAreas: dropDowns.operatingAreas,
      usedOnPublicRoadOptions: dropDowns.usedOnPublicRoadOptions,
      validated: false,
      financierOtherDisabled: true,
      enteredInsuredName: "",
      customerList: [],
      YIHQ_Customer_policy_guid: "",
      fileList: [],
      uploaderKey: 'quoteFileUploader',
      sentToCustomer: false,
      sentToBroker: false,
      hasFormChanges: false
    };
  },

  computed: {
    isFormValid() {




      var isValid = true;

      isValid = this.selectEquipmentItems.length > 0;

      //console.log(isValid);

      if (this.$refs.formValidator) {

        this.$refs.formValidator.validate();



        //console.log("errors");
        //console.log(this.$refs.formValidator.errors.length)
        //console.log(this.$refs.formValidator);

        // if (this.$refs.formValidator.errors.length > 0) {
        //   isValid = false;
        // }

        //   var customerDetailsValid = await this.$refs.formValidator.validate();
        //   console.log(customerDetailsValid);
        //   if (customerDetailsValid == false) {
        //     isValid = false;
        //   }
      }

      console.log(this.model.insuredABN);

      if (this.model.insuredABN == ""
        || this.model.businessDesc == ""
        || this.model.contactFName == ""
        || this.model.contactLName == ""
        || this.model.contactEmail == ""
        || this.model.contactPhone == ""
        || this.model.insuredCity == ""
        || this.model.insuredState == "") {
        isValid = false;
      }

      console.log(isValid);

      return isValid;
    },

    fieldsDisabled() {
      return quoteFormMethods.getDisabledFields(
        this.formMode,
        this.model.Customer_policy_status
      );
    },
    formRules() {
      return quoteFormMethods.getFormRules("in_progress");
    },
    brokerObj() {
      return GlobalStore.brokerObj;
    },
    showPremiumPanel() {
      const status = this.model && this.model.Customer_policy_status;
      return (
        this.hasQuotedPremium ||
        status === "in_progress" ||
        status === "offer_sent_awaiting_information" ||
        status === "offer_accepted"
      );
    },
    showGetPremiumButton() {
      const status = this.model && this.model.Customer_policy_status;
      const quotedClean =
        (this.uiMode === "view" || this.uiMode === "edit") &&
        status === "in_progress" &&
        this.quoteModified !== true;
      return !quotedClean ||
        status === "offer_sent_awaiting_information" ||
        status === "offer_accepted" ||
        this.quoteModified === true;
    },
    showSendOfferActions() {
      return this.uiMode === "view" &&
        this.model &&
        this.model.Customer_policy_status === "in_progress" &&
        this.quoteModified !== true;
    },
    totalPremiumIncFeesDisplay() {
      const raw = this.model?.Customer_policy_insurance_total_premium_plus_fees;
      if (raw === null || raw === undefined || raw === "") {
        return "";
      }
      const n = Number(raw);
      if (Number.isNaN(n)) {
        return "";
      }
      return n.toLocaleString("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    filesUploading() {
      return (this.fileList || []).some((f) => !f.success);
    },
    isQuoteOfferSent() {
      return this.sentToCustomer || this.sentToBroker;
    },
    quoteOfferSentRecipient() {
      if (this.sentToCustomer && this.sentToBroker) {
        return " to the customer and to the insurance broker";
      }
      if (this.sentToCustomer) {
        return " to the customer";
      }
      if (this.sentToBroker) {
        return " to the insurance broker";
      }
      return "";
    }
  },
  methods: {
    goToPSCreateQuote() {
      // Force a full navigation/reload so the create-quote form resets even when
      // the user is already on /ps-live/createQuote.
      const resolved = this.$router.resolve({
        path: "/ps-live/createQuote",
        query: { _: String(Date.now()) },
      });
      window.location.assign(resolved.href);
    },
    markFormDirty() {
      this.hasFormChanges = true;
    },
    hasUnsentCustomerQuote() {
      if (this.sentToCustomer || this.sentToBroker) {
        return false;
      }
      return this.hasFormChanges;
    },
    replaceAmp(ampString) {
      var fixedString = ampString.replace("&amp;", "&");
      return fixedString;
    },
    searchBusiness() {
      this.searchABNstring = this.model.insuredName;

      if (this.model.insuredName != "") {
        this.searchForABNFromModal();
      }

      this.$refs['abn-modal'].show();
    },
    closeModal() {
      this.$refs['abn-modal'].hide();
    },
    async useABNResult(abnObj) {
      var searchQuery = `https://abr.business.gov.au/json/AbnDetails.aspx?abn=` + abnObj.ABN + `&callback=callback&guid=30196ca0-bf23-468b-b7cc-8ea1ad330fb6`;

      const response = await axios.get(
        searchQuery,
        {
          responseType: 'text',
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      var cleanedResponse = JSON.parse(response.data.replaceAll("callback(", "").replace("})", "}"));

      var businessStartDate = new Date(cleanedResponse.AbnStatusEffectiveFrom);

      var a = this.$moment(new Date());
      var b = this.$moment(businessStartDate);

      var years = a.diff(b, 'year');

      this.model.insuredName = abnObj.organisationName;
      this.model.insuredABN = abnObj.ABN;
      this.model.yrsInOperation = years;

      this.model = { ...this.model };

      this.$refs['abn-modal'].hide();
    },
    async searchForABNFromModal() {
      var searchQuery = `https://abr.business.gov.au/json/MatchingNames.aspx?name=` + this.searchABNstring + `&callback=callback&guid=30196ca0-bf23-468b-b7cc-8ea1ad330fb6`;

      const response = await axios.get(
        searchQuery,
        {
          responseType: 'text',
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      var cleanedResponse = response.data.replaceAll("callback(", "").replace("})", "}");

      var searchResults = [];

      for (var item of JSON.parse(cleanedResponse).Names) {
        searchResults.push({
          organisationName: item.Name,
          score: item.Score,
          state: item.State,
          postCode: item.Postcode,
          ABN: item.Abn,
        });
      }

      this.ABNSearchResults = searchResults;
    },
    sanitiseDecimalInput(value) {
      const sanitisedValue = String(value || "").replace(/[^0-9.]/g, "");
      const [integerPart, ...decimalParts] = sanitisedValue.split(".");
      return decimalParts.length > 0
        ? integerPart + "." + decimalParts.join("")
        : integerPart;
    },
    parseSumInsured(value) {
      const parsed = parseFloat(this.sanitiseDecimalInput(value));
      return Number.isFinite(parsed) ? parsed : 0;
    },
    onSpecifiedSumInsuredInput(option, value) {
      option.insuredAmount = this.sanitiseDecimalInput(value);
      this.quoteChanged();
    },
    quoteChanged() {
      // Keep status so the premium panel stays visible; only mark dirty
      // so Get Premium reappears for a refresh.
      this.quoteModified = true;
    },
    applyQuotedPremium(resp) {
      this.uiMode = "view";
      this.$set(
        this.model,
        "Customer_policy_insurance_total_premium",
        resp.totalPremium
      );
      this.$set(
        this.model,
        "Customer_policy_insurance_total_premium_plus_fees",
        resp.totalPremiumIncFees
      );
      this.$set(
        this.model,
        "Customer_policy_insurance_premium",
        resp.grossBasePremium
      );
      this.$set(
        this.model,
        "Customer_policy_insurance_premium_gst",
        resp.gst
      );
      this.$set(
        this.model,
        "Customer_policy_insurance_premium_stamp_duty",
        resp.stampDuty
      );
      this.$set(this.model, "Customer_policy_status", "in_progress");
      this.hasQuotedPremium = true;
      this.quoteModified = false;
      this.quoteNotes = [];
      (resp.equipmentExcesses || []).forEach((item) => {
        this.quoteNotes.push(item.description);
      });
      (resp.equipmentMaxLiability || []).forEach((item) => {
        this.quoteNotes.push(item.description);
      });
      // updateQuote responses omit this; never wipe a guid from create
      if (resp.YIHQ_Customer_policy_guid) {
        this.YIHQ_Customer_policy_guid = resp.YIHQ_Customer_policy_guid;
      }
    },
    async customAction(file) {
      const blob = await fetch(file.blob).then((res) => res.blob());
      const base64data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      await appFunctions.addFinanceFileAttachment({
        Customer_policy_id: this.YIHQ_Customer_policy_guid,
        fileContent: base64data,
        filename: file.name,
        guid: GlobalMethods.uuidv4(),
        createdDateTime: new Date(),
        type: "ps-equipment-invoice",
      });

      return null;
    },
    /**
     * Has changed
     * @param  Object newFile Read only
     * @param  Object oldFile Read only
     */
    inputFile: function (newFile, oldFile) {

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log("response", newFile.response);
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }

      setTimeout(() => {
        if (
          Boolean(newFile) !== Boolean(oldFile) ||
          oldFile.error !== newFile.error
        ) {
          this.$refs[this.uploaderKey].active = true;
        }
      }, 2000);
    },
    /**
     * Pretreatment
     * @param  Object newFile Read and write
     * @param  Object oldFil  Read only
     * @param  Function prevent Prevent changing
     */
    inputFilter: function (newFile, oldFile, prevent) {
      let pending = (this.fileList || []).some((f) => f !== newFile && !f.success);
      if (newFile && !newFile.success) {
        pending = true;
      }
      this.$emit("disableNextStep", pending);

      if (newFile && !oldFile) {
        // Filter non-image file
        if (
          !/\.(jpeg|jpe|jpg|gif|png|webp|doc|docx|pdf|xls|xlsx|csv)$/i.test(
            newFile.name
          )
        ) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
    changeModeClicked(evt) {
      console.log(evt);
      //if (evt == "new") {
      this.model.insuredName = "";
      this.model.businessDesc = "";
      this.model.yrsInOperation = "";
      this.model.contactEmail = "";
      this.model.contactPhone = "";
      this.model.insuredStreet = "";
      this.model.insuredCity = "";
      this.model.insuredState = "";
      this.model.insuredPostcode = "";
      this.model.insuredABN = "";
      this.model.contactFName = "";
      this.model.contactLName = "";
      this.model.selectedCustomerId = "";
      this.model.Ubind_customer_id = "";

      if (evt == "new") {
        this.setFormDisabled(false)
      }
      else {
        this.setFormDisabled(true)
      }

    },
    setFormDisabled(disabled) {
      this.fieldsDisabled.insuredName = disabled
      this.fieldsDisabled.businessDesc = disabled
      this.fieldsDisabled.contactEmail = disabled
      this.fieldsDisabled.contactPhone = disabled
      this.fieldsDisabled.insuredStreet = disabled
      this.fieldsDisabled.insuredCity = disabled
      this.fieldsDisabled.insuredState = disabled
      this.fieldsDisabled.insuredPostcode = disabled
      this.fieldsDisabled.insuredABN = disabled
      this.fieldsDisabled.contactFName = disabled
      this.fieldsDisabled.contactLName = disabled
    },
    // selectCustomer(e) {
    //   console.log(e);
    //   //console.log(this.model.insuredName);
    //   if (e) {
    //     var findCustomer = this.customerList.find(f => f.value == e);
    //     this.enteredInsuredName = findCustomer.label.replace(
    //       / *\([^)]*\) */g,
    //       ""
    //     );
    //     this.model.insuredName = findCustomer.label.replace(
    //       / *\([^)]*\) */g,
    //       ""
    //     );

    //     console.log(findCustomer);

    //     GlobalStore.realmApp.functions
    //       .crud_customer("get", {
    //         Customer_id: parseInt(e)
    //       })
    //       .then(resp => {
    //         console.log(resp);
    //         var d = resp.data;
    //         this.model.businessDesc = d.Customer_business_description;
    //         this.model.contactEmail = d.Customer_contact_email;
    //         this.model.contactPhone = d.Customer_contact_number;
    //         this.model.insuredStreet = d.Customer_contact_street;
    //         this.model.insuredCity = d.Customer_contact_city;
    //         this.model.insuredState = d.Customer_state;
    //         this.model.insuredPostcode = d.Customer_postcode;
    //         this.model.insuredName = d.Customer_insured_name;
    //         this.model.insuredABN = d.Customer_abn;
    //         this.model.contactFName = d.Customer_contact_first_name;
    //         this.model.contactLName = d.Customer_contact_last_name;

    //         this.fieldsDisabled.businessDesc = true;
    //         this.fieldsDisabled.contactEmail = true;
    //         this.fieldsDisabled.contactPhone = true;
    //         this.fieldsDisabled.insuredStreet = true;
    //         this.fieldsDisabled.insuredCity = true;
    //         this.fieldsDisabled.insuredState = true;
    //         this.fieldsDisabled.insuredPostcode = true;
    //         //this.fieldsDisabled.insuredName = true;
    //         this.fieldsDisabled.insuredABN = true;
    //         this.fieldsDisabled.contactFName = true;
    //         this.fieldsDisabled.contactLName = true;

    //         this.selectedCustomerId = d.Customer_id;
    //       });
    //   }
    //   //   / *\([^)]*\) */g,
    //   //   ""
    //   // );
    // },
    // // InsuredNameBlurred(e) {
    // //   console.log(e);
    // //   this.model.insuredName = this.enteredInsuredName;

    // //   // if (this.model.insuredName.includes("(")) {
    // //   //   this.model.insuredName = this.model.insuredName.replace(
    // //   //     / *\([^)]*\) */g,
    // //   //     ""
    // //   //   );
    // //   // }
    // // },
    // // setInsuredName(e) {
    // //   //console.log(e);
    // //   //this.model.insuredName = e.target.value;

    // //   GlobalStore.realmApp.functions
    // //     .crud_customer("searchCustomerByRealmId", {
    // //       Realm_user_id: GlobalStore.brokerObj.Realm_user_id,
    // //       searchText: e.target.value
    // //     })
    // //     .then(resp => {
    // //       console.log(resp);
    // //       this.customerList = resp.data;
    // //     });

    // //   this.enteredInsuredName = e.target.value;
    // // },
    selectExcess(item, option) {

      this.quoteModified = true;

      item.selectedExcess = item.value;
      item.selectedExcessId = item.id;


      var itemToUpdate = this.selectEquipmentItems.find(f => f.categoryItemId == option.categoryItemId)
      console.log(itemToUpdate);


      itemToUpdate.selectedExcess = item.value;
      itemToUpdate.selectedExcessId = item.id;


      console.log(item);
      console.log(option);
    },
    toggleEquipmentItem(eqItem) {


      var findEI = this.selectEquipmentItems.find(f => f.categoryItemId == eqItem.categoryItemId);

      if (!findEI) {

        console.log(eqItem);

        var minExcess = 0;
        var minExcessId = 0;

        var excessOptions = this.formInitData.equipmentExcesses.map(m => {
          var enabled = false;

          // Default to the lowest allowed excess (first match), not the last.
          if (m.excessValue >= eqItem.minimumExcessAllowed) {
            enabled = true;
            if (!minExcessId || m.excessValue < minExcess) {
              minExcess = m.excessValue;
              minExcessId = m.excessId;
            }
          }
          return {
            label: "$" + m.excessValue,
            value: m.excessValue,
            id: m.excessId,
            enabled: enabled,
            selected: false
          }

        });



        this.selectEquipmentItems.push({
          categoryItemId: eqItem.categoryItemId,
          categoryName: eqItem.categoryName,
          excessOptions: excessOptions.filter(f => f.enabled == true),
          selectedExcess: minExcess,
          selectedExcessId: minExcessId,
          //selectedExcess: 0,
          //selectedExcessId: 0,
          insuredAmount: 0
          // {
          //   label: "$100",
          //   value: 100,
          //   enabled: false
          // },
          // {
          //   label: "$250",
          //   value: 250,
          //   enabled: true
          // },
          // {
          //   label: "$500",
          //   value: 500,
          //   enabled: true
          // },
          // {
          //   label: "$1000",
          //   value: 1000,
          //   enabled: true
          // }

        })

        //.map((m) => { return { ...m, ...{ selectedExcess: 0, insuredAmount: 0 } } })


      } else {
        this.selectEquipmentItems = this.selectEquipmentItems.filter(f => f.categoryItemId != eqItem.categoryItemId);
      }



    },
    selectCustomer(e) {
      this.markFormDirty();
      this.selected = true;
      if (e === null || e === undefined || e === "") {
        this.formData(null, false);
        return;
      }
      const findCustomer = this.customerList.find(f => f.Customer_id == e);
      if (findCustomer && findCustomer.Customer_email_opt_out === true) {
        this.$toasted
          .error(
            "This customer has opted out of emails and cannot be selected.",
            { position: "bottom-center" }
          )
          .goAway(4000);
        this.model.selectedCustomerId = "";
        this.formData(null, false);
        return;
      }
      this.enteredInsuredName = findCustomer
        ? findCustomer.Customer_insured_name
        : this.enteredInsuredName;
      if (findCustomer) {
        this.formData(findCustomer, true);
      } else {
        this.formData(null, false);
      }
    },
    formData(data, disabled) {
      this.model.insuredName = data ? data.Customer_insured_name : this.enteredInsuredName
      var findBusinessDesc = data ? this.businessDescriptionsOptions.find(f => f.value == data.Customer_business_description) : null;
      this.model.businessDesc = data ? (findBusinessDesc ? findBusinessDesc.value : "") : ""
      this.model.contactEmail = data ? data.Customer_contact_email : ""
      this.model.contactPhone = data ? data.Customer_contact_number : ""
      this.model.insuredStreet = data ? data.Customer_contact_street : ""
      this.model.insuredCity = data ? data.Customer_contact_city : ""
      this.model.insuredState = data ? data.Customer_state : ""
      this.model.insuredPostcode = data ? data.Customer_postcode : ""
      this.model.insuredABN = data ? data.Customer_abn : ""
      this.model.contactFName = data ? data.Customer_contact_first_name : ""
      this.model.contactLName = data ? data.Customer_contact_last_name : ""
      this.model.selectedCustomerId = data ? data.Customer_id : ""
      this.model.Ubind_customer_id = data ? data.Ubind_customer_id : ""
      this.fieldsDisabled.insuredName = disabled
      this.fieldsDisabled.businessDesc = disabled
      this.fieldsDisabled.contactEmail = disabled
      this.fieldsDisabled.contactPhone = disabled
      this.fieldsDisabled.insuredStreet = disabled
      this.fieldsDisabled.insuredCity = disabled
      this.fieldsDisabled.insuredState = disabled
      this.fieldsDisabled.insuredPostcode = disabled
      this.fieldsDisabled.insuredABN = disabled
      this.fieldsDisabled.contactFName = disabled
      this.fieldsDisabled.contactLName = disabled
      this.fieldsDisabled.financier = disabled
    },
    InsuredNameBlurred(e) {
      if (this.enteredInsuredName && this.enteredInsuredName.trim() !== "") {
        this.markFormDirty();
      }
      this.model.insuredName = this.enteredInsuredName;
    },
    setInsuredName(e) {
      this.enteredInsuredName = e.target.value;
      if (this.enteredInsuredName && this.enteredInsuredName.trim() !== "") {
        this.markFormDirty();
      }
    },

    visibleChange(e) {
      if (e) {
        // Opening the dropdown — wait for a new selection.
        this.selected = false;
        return;
      }
      // Closing: run after @change so a real selection isn't wiped.
      this.$nextTick(() => {
        if (!this.selected) {
          this.model.insuredName = this.enteredInsuredName;
          if (this.enteredInsuredName && this.enteredInsuredName.trim() !== "") {
            this.formData(null, false);
          }
        }
      });
    },
    scrollUp() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.topSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#topSection" // required if updateHistory is true
      });
    },
    scrollDown() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.calcSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#calcSection" // required if updateHistory is true
      });
    },

    async createNewQuote() {

      var totalExcess = this.selectEquipmentItems.reduce((a, b) => a + b.selectedExcess, 0);

      this.quoteModified = false;

      let internalCustId = this.model.selectedCustomerId;

      if (!this.model.selectedCustomerId) {
        var newCustomer = {
          Customer_insured_name: this.model.insuredName,
          Customer_abn: this.model.insuredABN,
          Customer_contact_first_name: this.model.contactFName,
          Customer_contact_last_name: this.model.contactLName,
          Customer_contact_email: this.model.contactEmail,
          Customer_contact_number: this.model.contactPhone,
          Customer_contact_street: this.model.insuredStreet,
          Customer_contact_city: this.model.insuredCity,
          Customer_state: this.model.insuredState,
          Customer_postcode: this.model.insuredPostcode,
          Customer_country: "",
          Customer_business_description: this.model.businessDesc,
          Broker_org_id: GlobalStore.brokerObj.parentOrg.Broker_org_id,
          Broker_id: GlobalStore.brokerObj.Broker_id,
          Insurance_broker_id:
            GlobalStore.brokerObj.parentOrg.parentInsuranceBroker
              .insurance_broker_id
        };

        const customerResp = await appFunctions.crud_customer(
          "create",
          newCustomer
        );

        if (!customerResp.data.Customer_id) {
          toasts.error(
            "Uh ohh... could not create " +
            formModel.insuredName +
            " please try again."
          );
          return;
        }

        internalCustId = customerResp.data.Customer_id;
      }

      var quoteToSend = {
        "brokerId": GlobalStore.brokerObj.Broker_id,
        "type": "light-machinery",
        "inceptionDate": this.model.policyStart,
        "expiryDate": this.model.expiryDate,
        "periodOfCover": 12,
        "insuredPostcode": this.model.insuredPostcode,
        "insuredState": this.model.insuredState,
        "insuredSuburb": this.model.insuredCity,
        "insuredName": this.model.insuredName,
        "excess": totalExcess,
        "registeredForGst": this.model.registeredForGST,
        "source": "YIHQ Form",
        "equipmentItems": this.selectEquipmentItems.map(m => {
          return {
            "itemId": m.categoryItemId,
            "specifiedSumInsured": this.parseSumInsured(m.insuredAmount),
            "unSpecifiedSumInsured": 0,
            "excessId": m.selectedExcessId
          }
        }),
        "customFields": {
          "customerId": internalCustId,
          "claimsOrLossesLast3Years": false,
          "moreThan50k": false,
          "isChubbCurrentlyUnderWriting": false
        }
      }


      console.log(quoteToSend);
      //console.log(totalExcess);
      //console.log(this.selectEquipmentItems);


      this.isLoading = true;

      var brokerFees = 0;

      //console.log()





      protecsureFunctions.requestQuote(quoteToSend).then(async (resp) => {
        console.log(resp);

        this.quoteId = resp.quoteId;
        this.applyQuotedPremium(resp);
        this.isLoading = false;
        this.scrollDown();
      }).catch(() => {
        this.isLoading = false;
      })


    },
    async updateQuote() {

      var totalExcess = this.selectEquipmentItems.reduce((a, b) => a + b.selectedExcess, 0);

      let internalCustId = this.model.selectedCustomerId;
      /*
      if (!this.model.selectedCustomerId) {
        var newCustomer = {
          Customer_insured_name: this.model.insuredName,
          Customer_abn: this.model.insuredABN,
          Customer_contact_first_name: this.model.contactFName,
          Customer_contact_last_name: this.model.contactLName,
          Customer_contact_email: this.model.contactEmail,
          Customer_contact_number: this.model.contactPhone,
          Customer_contact_street: this.model.insuredStreet,
          Customer_contact_city: this.model.insuredCity,
          Customer_state: this.model.insuredState,
          Customer_postcode: this.model.insuredPostcode,
          Customer_country: "",
          Customer_business_description: this.model.businessDesc,
          Broker_org_id: GlobalStore.brokerObj.parentOrg.Broker_org_id,
          Broker_id: GlobalStore.brokerObj.Broker_id,
          Insurance_broker_id:
            GlobalStore.brokerObj.parentOrg.parentInsuranceBroker
              .insurance_broker_id
        };

        const customerResp = await appFunctions.crud_customer(
          "create",
          newCustomer
        );

        if (!customerResp.data.Customer_id) {
          toasts.error(
            "Uh ohh... could not create " +
            formModel.insuredName +
            " please try again."
          );
          return;
        }

        internalCustId = customerResp.data.Customer_id;
      }
        */

      var quoteToSend = {
        "quoteId": this.quoteId,
        "brokerId": GlobalStore.brokerObj.Broker_id,
        "type": "light-machinery",
        "inceptionDate": this.model.policyStart,
        "expiryDate": this.model.expiryDate,
        "periodOfCover": 12,
        "insuredPostcode": this.model.insuredPostcode,
        "insuredState": this.model.insuredState,
        "insuredSuburb": this.model.insuredCity,
        "insuredName": this.model.insuredName,
        "excess": totalExcess,
        "registeredForGst": this.model.registeredForGST,
        "source": "YIHQ Form",
        "equipmentItems": this.selectEquipmentItems.map(m => {
          return {
            "itemId": m.categoryItemId,
            "specifiedSumInsured": this.parseSumInsured(m.insuredAmount),
            "unSpecifiedSumInsured": 0,
            "excessId": m.selectedExcessId
          }
        }),
        "customFields": {
          "customerId": internalCustId,
          "claimsOrLossesLast3Years": false,
          "moreThan50k": false,
          "isChubbCurrentlyUnderWriting": false
        }
      }


      console.log(quoteToSend);
      //console.log(totalExcess);
      //console.log(this.selectEquipmentItems);


      this.isLoading = true;

      var brokerFees = 0;

      //console.log()





      protecsureFunctions.updateQuote(quoteToSend).then(async (resp) => {
        console.log(resp);

        this.applyQuotedPremium(resp);
        this.isLoading = false;
        this.scrollDown();
      }).catch(() => {
        this.isLoading = false;
      })


    },
    async doQuote() {
      if (this.quoteId == null) {
        this.createNewQuote();
      } else {
        this.updateQuote();
      }
    },
    emailOffer(_type) {
      if (!this.YIHQ_Customer_policy_guid) {
        this.$toasted
          .error("Quote reference is missing. Please Get Premium again before sending.", {
            position: "bottom-center"
          })
          .goAway(5000);
        return;
      }

      if (_type == "customer") {
        if (!this.model.contactEmail) {
          this.$toasted
            .error("Contact email is required before sending to the customer.", {
              position: "bottom-center"
            })
            .goAway(4000);
          return;
        }

        appFunctions
          .crud_customerPolicy("updatePSQuoteByGuid", {
            policy_id: this.YIHQ_Customer_policy_guid,
            financier: this.model.financier,
            financierOther: this.model.financierOther,
            status: peQuoteStatus.consentEmailSent,
          })
          .then(() => {
            appFunctions
              .crud_customerPolicy("getCombinedByGuid", {
                policy_id: this.YIHQ_Customer_policy_guid,
              })
              .then(resp => {
                const policy = resp && resp.data ? { ...resp.data } : {};
                if (!policy.Customer_contact_email && this.model.contactEmail) {
                  policy.Customer_contact_email = this.model.contactEmail;
                }
                if (!policy.Customer_contact_first_name && this.model.contactFName) {
                  policy.Customer_contact_first_name = this.model.contactFName;
                }
                if (!policy.Customer_policy_guid) {
                  policy.Customer_policy_guid = this.YIHQ_Customer_policy_guid;
                }

                if (!policy.Customer_contact_email) {
                  this.$toasted
                    .error("Customer email is missing on this quote. Check the contact email and try again.", {
                      position: "bottom-center"
                    })
                    .goAway(5000);
                  return;
                }

                emailMethods.sendPSConsentToContinueQuoteEmail(
                  GlobalStore.realmApp,
                  policy,
                );
              });

            this.sentToCustomer = true;
          });

      } else {
        appFunctions
          .crud_customerPolicy("updatePSQuoteByGuid", {
            policy_id: this.YIHQ_Customer_policy_guid,
            financier: this.model.financier,
            financierOther: this.model.financierOther,
            status: peQuoteStatus.sentToBroker,
          })
          .then(() => {
            appFunctions
              .crud_customerPolicy("getCombinedByGuid", {
                policy_id: this.YIHQ_Customer_policy_guid,
              })
              .then(resp => {
                const policy = resp && resp.data ? { ...resp.data } : {};
                if (!policy.Customer_policy_guid) {
                  policy.Customer_policy_guid = this.YIHQ_Customer_policy_guid;
                }

                emailMethods.sendPSContinueQuoteEmailToBroker(
                  GlobalStore.realmApp,
                  policy,
                  this.selectedBrokerEmail
                );
              });

            this.sentToBroker = true;
          });
      }
    },
    editQuote() {
      this.formMode = "edit";
      this.scrollUp();
    },
    async changeInceptionDate(evt) {
      //console.log(evt.target.value);


      //console.log(this.$moment(new Date(evt.target.value)).add(1,'y').format('YYYY-MM-DD'));

      this.model.expiryDate = this.$moment(new Date(evt.target.value)).add(1, 'y').format('YYYY-MM-DD')

      // protecsureFunctions.getUpdatedPeriodOfCover(evt.target.value).then(resp => {
      //   this.expiryDate = resp.periodOfCover.expiryDate 

      // });
    },
    // updateQuote() {
    //   var calcData = quoteFormMethods.getCalculation(this.model);

    //   this.model.Customer_policy_insurance_total_premium =
    //     calcData.Customer_policy_insurance_total_premium;
    //   this.model.Customer_policy_insurance_premium =
    //     calcData.Customer_policy_insurance_premium;
    //   this.model.Customer_policy_insurance_premium_gst =
    //     calcData.Customer_policy_insurance_premium_gst;
    //   this.model.Customer_policy_insurance_premium_stamp_duty =
    //     calcData.Customer_policy_insurance_premium_stamp_duty;
    //   this.model.Customer_policy_fee = calcData.Customer_policy_fee;

    //   quoteFormMethods.updateQuote(this.realmApp, this.rawModel, this.model);

    //   this.scrollDown();

    //   this.formMode = "view";
    // },
    firstFormSubmit() {
      console.log("clicked");
    },
    readBrokerEmail(event) {

    },
    readFinancier(event) {
      console.log("typed");
      if (event == "Other") {
        this.financierOtherDisabled = false;
        //this.model.financier = "";
      } else {
        this.financierOtherDisabled = true;
        this.model.financierOther = "";
      }
    },
    /**
     * @desc Clears the address city, state and postcode fields when the street
     * field is cleared.
     */
    clearAddressFields() {
      if (this.model.insuredStreet == "") {
        this.model.insuredCity = "";
        this.model.insuredState = "";
        this.model.insuredPostcode = "";
      }
    },
    updateAddressFields(address, street, city, state, postcode) {
      this.$set(this.model, "insuredAddress", address || "");
      this.$set(this.model, "insuredStreet", street || "");
      this.$set(this.model, "insuredCity", city || "");
      this.$set(this.model, "insuredState", state || "");
      this.$set(this.model, "insuredPostcode", postcode || "");
      // Force child re-render (same pattern as motor QuoteFormMotor)
      this.model = { ...this.model };
    },
  },

  async mounted() {

    this.isLoading = true;


    console.log(GlobalStore);


    await appFunctions.crud_brokerOrg("getBrokerList", {
      Broker_org_id: GlobalStore.brokerObj.Broker_org_id
    })
      .then(resp => {
        console.log(resp.data);
        var _brokerList = resp.data.map(m => {
          return {
            label: m.Broker_first_name + ' ' + m.Broker_last_name,
            value: m.Broker_email
          }
        })

        this.brokerEmailList = _brokerList;

        console.log(_brokerList);

      });



    await appFunctions.crud_customerLCPolicy("getCombinedByRealmId", {
      Realm_user_id: GlobalStore.brokerObj.Realm_user_id
    })
      .then(resp => {

        var customers = resp.data.filter(data => data && data.Customer_insured_name);

        customers.sort(function (a, b) {
          return ('' + a.Customer_insured_name).localeCompare(b.Customer_insured_name);
        })



        this.customerList = customers;

      });


    this.fieldsDisabled.businessDesc = false;
    this.fieldsDisabled.contactEmail = false;
    this.fieldsDisabled.contactPhone = false;
    this.fieldsDisabled.insuredStreet = false;
    this.fieldsDisabled.insuredCity = false;
    this.fieldsDisabled.insuredState = false;
    this.fieldsDisabled.insuredPostcode = false;
    //this.fieldsDisabled.insuredName = true;
    this.fieldsDisabled.insuredABN = false;
    this.fieldsDisabled.contactFName = false;
    this.fieldsDisabled.contactLName = false;

    this.fieldsDisabled.policyStart = false;
    this.fieldsDisabled.expiryDate = false;

    this.fieldsDisabled.insuredName = false;

    this.fieldsDisabled.financier = false;


    try {
      protecsureFunctions.getFormInitData().then(resp => {
        console.log(resp);

        this.formInitData = resp;

        this.model.policyStart = resp.periodOfCover[0].inceptionDate;
        this.model.expiryDate = resp.periodOfCover[0].expiryDate;

        this.model.registeredForGST = true;

        this.model.claimsOrLossesLast3Years = false;
        this.model.moreThan50k = false;

        this.model.financier = null

        this.isLoading = false;

        setTimeout(async () => {
          await this.$refs.formValidator.validate();
        }, 2000);

      });
    } catch {
      console.log("Could not get InitData from PS");
      this.isLoading = false;
    }




    /******** temp */
    /*
    this.formInitData = {
      "periodOfCover": [
        {
          "@odata.etag": "W/\"JzQ0O0NlNW1wTFNWdWp6YlEwT3RLMUVORUt6eGlxdFhmMHBheVd5V3RVY0tIU2M9MTswMDsn\"",
          "documentType": "Quote",
          "no": "",
          "inceptionDate": "2025-04-28",
          "expiryDate": "2026-04-28",
          "periodOfCover": 12,
          "minimumInceptionDate": "2025-04-28",
          "maximumInceptionDate": "2025-05-28",
          "minimumExpiryDate": "2025-05-28",
          "maximumExpiryDate": "2027-04-28"
        }
      ],
      "equipmentExcesses": [
        {
          "@odata.etag": "W/\"JzQ0O0F3RitBNWROUElDeXRyNDBmd0pHQVpyb3dYTWxXQTVkM0hlMm02RzhVbEE9MTswMDsn\"",
          "calculationType": "Equipment",
          "excessId": 10000,
          "excessValue": 100
        },
        {
          "@odata.etag": "W/\"JzQ0O1Y5L3RxM1E4SUhHSys5T3B2T0U3NVhhRys0NVpmUGpOTUtrUHhxR0IxYTQ9MTswMDsn\"",
          "calculationType": "Equipment",
          "excessId": 30000,
          "excessValue": 500
        }
      ],
      "equipmentCategories": [
        {
          "categoryCode": "18",
          "categoryTooltip": "Dingo's, Excavators, Forklifts, Scissor Lift, Tractors, Turf Grader, Unregistered Mobile Plant & Machinery, Generators > 50KVA",
          "categoryName": "Unregistered Mobile Plant & Machinery",
          "minimumExcessAllowed": 500,
          "categoryItemId": 275
        },
        {
          "categoryCode": "2",
          "categoryTooltip": "Air Compressors > 10hp, Concrete Cutting Equipment (Cart), Concrete Mixers, Concrete Pumps, Core Drilling Equipment, Floor Polishing Equipment, Generators 10KVA > 50KVA, High Pressure Jet Washers, Jack Hammers (Pneumatic), Laser Screed, Lawn Mowers (Ride On), Portable Traffic Lights, Pumps > 20hp (Portable), Steam Cleaning Equipment (Incl. Carpet Cleaners), Transformers, Tree Stump Grinders, Water Pump, Light Machinery, Welders (>200 amps)",
          "categoryName": "Light Machinery",
          "minimumExcessAllowed": 250,
          "categoryItemId": 266
        }
      ]
    }

    this.model.policyStart = this.formInitData.periodOfCover[0].inceptionDate;
    this.model.expiryDate = this.formInitData.periodOfCover[0].expiryDate;

    this.model.registeredForGST = true;

    this.model.claimsOrLossesLast3Years = false;
    this.model.moreThan50k = false;

    this.isLoading = false;

*/
    /******* temp end */






    // this.formMode = this.mode;
    // this.realmApp = GlobalStore.realmApp;

    // this.policy_id = this.$route.params.id;

    // this.selectedCustomerId = 0;

    // //changeStatus();

    // let script = document.createElement("script");
    // script.setAttribute(
    //   "src",
    //   "https://api.addressfinder.io/assets/v3/widget.js"
    // );
    // script.setAttribute("async", true);
    // script.onload = () => {
    //   this.widget = new window.AddressFinder.Widget(
    //     document.getElementById("addrs_1"),
    //     "NMY9RTVQ3UHADL76FJ8G",
    //     "AU",
    //     {
    //       address_params: {
    //         gnaf: 1
    //       }
    //     }
    //   );
    //   this.widget.on("result:select", (fullAddress, metaData) => {
    //     this.model.insuredAddress = metaData.address_line_1;
    //     this.model.insuredStreet = metaData.address_line_1;
    //     this.model.insuredCity = metaData.locality_name;
    //     this.model.insuredState = metaData.state_territory;
    //     this.model.insuredPostcode = metaData.postcode;
    //   });
    // };
    // document.head.appendChild(script);

    // console.log(this.$route.params.status);

    // if (this.$route.query.status) {
    //   this.scrollDown();
    // }
  },
  components: {
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
    Spinner,
    ButtonRadioGroup,
    FileUpload
  },
  directives: {
    /**
     * Used ensure the keyboard is shown on mobile devices when clicking on an el-select.
     * This is because element-ui was not designed for mobile:
     * https://github.com/ElemeFE/element/issues/12742#issuecomment-420866658
     */
    cancelReadOnly(el) {
      const input = el.querySelector(".el-input__inner");
      input.removeAttribute("readonly");
    }
  }
};
</script>
<style>
.abn-link {
  font-size: 9pt;
  color: var(--uBind) !important;
  position: absolute;
  right: 0px;
  margin-right: 10px;
}

.eq-selected {
  border: 2px black solid !important;
}
</style>
